import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 20\" id=\"icon-calendar\"><path d=\"M12 0h2v2h4v18H0V2h4V0h2v2h6zM1 3v3h16V3zm0 4v12h16V7zm3 3h2v2H4zm6 0H8v2h2zm2 0h2v2h-2zm-6 4H4v2h2zm2 0h2v2H8zm6 0h-2v2h2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol